import { Text, type TextProps } from "@mantine/core";
import { ReactNode } from "react";

// 1. Định nghĩa tất cả các trường hợp Text trong hệ thống của bạn
export type CustomTextVariant =
  | "page-title"
  | "section-title"
  | "body"
  | "label"
  | "caption"
  | "error"
  | "product-label";

interface CustomTextProps extends TextProps {
  variant?: CustomTextVariant;
  children: ReactNode;
  htmlFor?: string; // Dành riêng cho trường hợp dùng làm thẻ <label>
}

// 2. Dictionary Pattern: Map mỗi variant với style và thẻ HTML ngữ nghĩa tương ứng
const VARIANTS: Record<CustomTextVariant, TextProps & { component?: any }> = {
  "page-title": {
    component: "h2",
    fz: "h2",
    fw: 700,
    c: "dark.9",
    mb: "md",
    mt: 0,
  },
  "section-title": {
    // component: "h4",
    fz: "h4",
    fw: 600,
    c: "dark.8",
    mb: 0,
    mt: 0,
  },
  body: { component: "p", fz: "sm", fw: 400, m: 0 },

  // label được set display block/inline-block để nhận margin
  label: {
    component: "label",
    fz: "sm",
    fw: 500,
    c: "dark.8",
    display: "inline-block",
    mb: 4,
  },

  "product-label": {
    component: "p",
    fz: "sm",
    fw: 600,
    mt: 2,
    m: 2,
  },

  caption: { component: "span", fz: "xs", fw: 400, c: "dimmed" },
  error: { component: "p", fz: "xs", fw: 500, c: "red.6", mt: 4, m: 0 },
};

// 3. Component chính
const CustomText = ({
  variant = "body",
  children,
  htmlFor,
  ...others
}: CustomTextProps) => {
  // Lấy cấu hình mặc định từ Dictionary
  const variantStyles = VARIANTS[variant];

  return (
    <Text
      {...variantStyles}
      htmlFor={variant === "label" ? htmlFor : undefined}
      {...others} // Cho phép ghi đè mọi prop từ bên ngoài khi cần thiết
    >
      {children}
    </Text>
  );
};

export default CustomText;
